// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import axios from 'axios'
import store from './store'
import '../src/api/httpService'
import './utils/rem'
import { Picker } from 'vant'
import { Popup } from 'vant'
import { Tab, Tabs } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Icon } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Tabbar, TabbarItem } from 'vant';
import { Switch } from 'vant'
import { Step, Steps } from 'vant'
import { Field } from 'vant'
import { NavBar } from 'vant';
import vueEsign from 'vue-esign'
import {ImagePreview} from 'vant';
import moment from 'moment'
import 'vue-easytable/libs/themes-base/index.css'
import {VTable,VPagination} from 'vue-easytable'
import echarts from 'echarts'
import cookie from 'vue-cookie'
import VConsole from "vconsole";
// const vConsole = new VConsole()
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
Vue.use(ImagePreview)
Vue.use(Picker).use(Step).use(Steps).use(Field).use(Popup).use(Tab).use(Switch).use(Tabs).use(Cell).use(CellGroup).use(Icon).use(RadioGroup).use(Radio).use(Tabbar).use(TabbarItem)
Vue.use(Mint)
Vue.use(NavBar);
// Vue.use(vConsole);
console.log('vconsole-test')

Vue.use(vueEsign);
import 'mint-ui/lib/style.css'
console.log(process.env.API_HOST, 'process.env.API_HOST')
Vue.config.productionTip = false
Vue.prototype.$http= axios
Vue.prototype.$store = store
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
Vue.prototype.$cookie = cookie
moment.locale('zh-cn');//需要汉化
export default new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js